import {css} from 'aphrodite';
import React from 'react';

import BenchChip from 'ui-library/chips/BenchChip';
import {ChipSize} from 'ui-library/chips/Chip';

import {PROCESS_TASK_DETAILS_PAGE_STYLES, ProcessTaskGql} from '../ProcessTaskDetailsPageConstants';
import PlaceholderFieldValue from './PlaceholderFieldValue';

export default function SourceTasksAndOutputsField({
  processTask,
}: {
  processTask: ProcessTaskGql;
}): JSX.Element {
  return (
    <>
      {processTask.lineageEdgesTo.length > 0 ? (
        processTask.lineageEdgesTo.map(({fromVertex}, index) => (
          <BenchChip
            className={css(PROCESS_TASK_DETAILS_PAGE_STYLES.chipHeight)}
            key={index}
            id={fromVertex.id}
            size={ChipSize.TABLE_CELL}
          />
        ))
      ) : (
        <PlaceholderFieldValue />
      )}
    </>
  );
}
